<div>
    <h3 class="cdp-filter-drawer-header">
        <span><span class="icon-filters icon-left"></span>Filters</span>
        <button hc-icon-button class="cdp-simple-ico-btn" title="Close drawer" (click)="closeDrawer.emit()">
            <hc-icon fontIcon="icon-close"></hc-icon>
        </button>
    </h3>
    @if (loading || loadFailed) {
        <div class="cdp-grid-empty cdp-grid-empty-sidebar-mini cdp-fade-in">
            @if (loading) {
                <hc-progress-dots></hc-progress-dots>
            } @else if (loadFailed) {
                <span class="icon-warn cdp-grid-empty-ico"></span>
                <p>Filters failed to load</p>
            }
        </div>
    } @else {
        <form [formGroup]="form">
            <div class="cdp-form-field">
                <cdp-filter-item
                    [filterItems]="filters"
                    [form]="form"
                    (selectionChange)="onSelectionChange($event)"
                ></cdp-filter-item>
            </div>
        </form>
    }
    <button hc-button class="drawer-state-btn" buttonStyle="minimal" title="Close drawer" (click)="closeDrawer.emit()">
        <span class="icon-chev-left"></span>
    </button>
</div>
